/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPREDUCTIONININCOME = {
    None: '1',
    AtFirstDeath: '2',
    AtSpecificDeath: '3'
} as const;
export type IAPREDUCTIONININCOME = typeof IAPREDUCTIONININCOME[keyof typeof IAPREDUCTIONININCOME];


export function IAPREDUCTIONININCOMEFromJSON(json: any): IAPREDUCTIONININCOME {
    return IAPREDUCTIONININCOMEFromJSONTyped(json, false);
}

export function IAPREDUCTIONININCOMEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPREDUCTIONININCOME {
    return json as IAPREDUCTIONININCOME;
}

export function IAPREDUCTIONININCOMEToJSON(value?: IAPREDUCTIONININCOME | null): any {
    return value as any;
}

